<template>
  <footer class="text-center mt-4">
    <p style="font-size: 13px">
      ©{{ new Date().getFullYear() }}
      <a target="_blank" style="text-decoration: none" href="https://bitlab.rs/">
        {{ toLatin("БитЛаб д.о.о") }}
      </a>
      {{ $t("all_rights_reserved") }}.
      <a target="_blank" style="text-decoration: none" href="https://privacy.ordera.app/">
        {{ $t("privacy_policy") }}
      </a>
    </p>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>
